import React from 'react'
import styled, { keyframes } from 'styled-components'

const RemoveTagModal = (props) => {
  // CALCULATE AVAILABLE CATEGORY OPTIONS
  async function submit() {
    props.deleteTagRequest()
    leaveModal()
    props.setTagRemovalModal(false)
  }

  if (props.isOpen) {
    let scrollbarWidth = window.innerWidth - document.body.clientWidth + 'px'
    document.body.style.overflow = 'hidden'
    document.body.style.margin = `0 ${scrollbarWidth} 0 0`
  } else {
    document.body.style.overflow = 'visible'
    document.body.style.margin = '0'
  }

  const leaveModal = () => {
    document.body.style.overflow = 'visible'
    document.body.style.margin = '0'
  }

  return (
    <Container>
      <Modal>
        <ModalBody>
          <H1>Are you sure you want to remove the category: "{props.tagName}"?</H1>
          <Label>
            Removing this tag will unlink it from any packages and remove its section from your portfolio.
          </Label>

          <Row1>
            <CancelButton
              onClick={() => {
                leaveModal()
                props.setTagRemovalModal(false)
              }}
              id="cancel-tag"
            >
              Cancel
            </CancelButton>
            <Button onClick={submit} id="create-tag">
              Remove
            </Button>
          </Row1>
        </ModalBody>
      </Modal>
      <ScreenDimmer
        onClick={() => {
          leaveModal()
          props.setTagRemovalModal(false)
        }}
      ></ScreenDimmer>
    </Container>
  )
}

export default RemoveTagModal

const fadeIn = keyframes`
  0% {
    top: 0%;
    left: 50%;
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  100% {
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      opacity: 1;
  }
`

const Modal = styled.div`
  position: absolute;
  margin: 4em 0;
  top: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  width: 31.25em;
  background: #fff;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 16px;
  animation: 0.2s ${fadeIn} ease-out;
  @media (max-width: 550px) {
    font-size: 15px;
    height: auto;
  }
  @media (max-width: 500px) {
    font-size: 14px;
  }
  @media (max-width: 480px) {
    font-size: 13px;
  }
  @media (max-width: 450px) {
    width: 95%;
  }
`

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  overflow-y: scroll;
`

const ScreenDimmer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  z-index: 1;
  opacity: 0.1;
`

const Button = styled.button`
  font-size: 14px;
  min-width: 110px;
  color: white;
  background: var(--forward);
  height: ${(props) => (props.height ? props.height : '3em')};
  border: none;
  padding: 0 1em;
  text-transform: none;
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
  :hover {
    opacity: 0.9;
  }
`

const CancelButton = styled(Button)`
  background: #ec6a34;
`

const ModalBody = styled.div`
  width: 90%;
  padding: 1.5em 1em;
`

const H1 = styled.h3`
  color: var(--black);
  padding: 0;
  font-size: 28px;
`

const Label = styled.h3`
  color: var(--black);
  font-size: 18px;
  margin: 1.5em 0 0.25em 0;
  line-height: 1.5;
`

const Row1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 2.5em 0 1em 0;
`
